import { render, staticRenderFns } from "./footerMore.vue?vue&type=template&id=299b2c58&scoped=true"
import script from "./footerMore.vue?vue&type=script&lang=js"
export * from "./footerMore.vue?vue&type=script&lang=js"
import style0 from "./footerMore.vue?vue&type=style&index=0&id=299b2c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299b2c58",
  null
  
)

export default component.exports